import { Component, OnInit } from '@angular/core';
import { Modal } from 'src/app/models/Modal.model';
import { ModalNames } from '../Modal';

@Component({
    templateUrl: './success-login.modal.html'
})
export class SuccessLoginModalComponent extends Modal {

    public confirmText = localStorage.getItem('retryRun') === 'true'
        ? 'Naar leerfase'
        : 'Naar reflectie';

    onInjectInputs(): void {
        return null;
    }

    allowDimmerClose(): boolean {
        return false;
    }
  
    getName(): ModalNames {
        return ModalNames.SUCCESS_LOGIN;
    }
}